import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioButtonUnchecked = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 8.7,
		fill: "none",
		stroke: "#E2E4E9",
		strokeWidth: 1.8
	})
});
const ForwardRef = forwardRef(SvgRadioButtonUnchecked);
export default ForwardRef;
